module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mx-0",
    class: {
      "py-4": !!_vm.data.find(function (el) { return Number(el.count > 0); })
    }
  }, _vm._l((_vm.data), function(elem, index) {
    return (Number(elem.count) > 0) ? _c('div', {
      key: elem.id,
      staticClass: "statistic_block col-12 col-sm-6 col-md-4 col-lg-3 px-0"
    }, [_c('div', {
      staticClass: "separator",
      style: ({
        borderColor: _vm.colorMap[index % _vm.colorMap.length]
      })
    }), _c('div', {
      staticClass: "statistic_data"
    }, [_c('div', {
      staticClass: "statistic_count"
    }, [_vm._v(_vm._s(elem.count))]), _c('div', {
      staticClass: "statistic_text"
    }, [_vm._v(_vm._s(elem.column_name))])])]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30134aca","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/statistic/Statistics.vue
// module id = 05c73c659a3bbc597c9d
// module chunks = 0